// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import loadBargainBinProducts from "@awc/App/Handlers/BargainBin/GetBargainProducts";
import {
    BargainBinCategoriesModel,
    BargainCategoriesApiParameter,
    getBargainBinCategories,
} from "@awc/App/Services/BargainBin";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getQueryStrings } from "@insite/client-framework/Store/Data/Pages/PageSelectors";


type HandlerType = ApiHandler<
    BargainCategoriesApiParameter & HasOnSuccess<ServiceResult<BargainBinCategoriesModel>> & HasOnError<string>,
    ServiceResult<BargainBinCategoriesModel>>;

export const PopulateApiParameters: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.dispatch({
        type: "xBargain/SetIsLoadingCategories",
        IsLoadingCategories: true,
    } as any);
    props.apiResult = await getBargainBinCategories(props.apiParameter);
};

export const DispatchCompleteLoadBargainBinCategories: HandlerType = props => {
    props.dispatch({
        type: "xBargain/LoadingCategoriesCompleted",
        categories: (props.apiResult as any)?.result?.bargainBinCategories,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult);
        // get product
        const { productId } = getQueryStrings(props.getState());

        if (productId) {
            props.dispatch(loadBargainBinProducts({
                productId,
                bargainBinCategory: props.apiParameter.bargainBinCategory,
                isBargainBinPage: true,
            }));
        }
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.dispatch({
            type: "xPagesContent/FailedToLoadPagesContent",
            key: (props as any).key,
        } as any);
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const chain = [PopulateApiParameters, RequestDataFromApi, DispatchCompleteLoadBargainBinCategories, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const loadBargainBinCategories = createHandlerChainRunner(chain, "loadBargainBinCategories");

export default loadBargainBinCategories;
